import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IWaterSystemsData, WaterSystemsInitialState } from '../waterSystems.slice';
import { AxiosResponse} from 'axios';
import { EpaApi } from '../../../services';

export const fetchPublicWaterSystemsByAddressComponentAsync = createAsyncThunk(
    'systems/fetchSystemsByAddressComponent',
    async ({ city, state, zipCode, address1 }: { city: string, state: string, zipCode: string, address1: string },
   { rejectWithValue },) => {
      try {
        const response = await EpaApi.fetchPublicWaterSystemsByAddressComponent(city, state, zipCode, address1);
        return (response as AxiosResponse<any,any>).data;
      } catch (error: any) {
        console.error(error);
        return rejectWithValue({
          message: error?.response?.data?.message || "Unexpected error occurred"
        });
      }
    }
  );

export const fetchPublicWaterSystemsByAddressComponentAsyncBuilder = (
    builder: ActionReducerMapBuilder<WaterSystemsInitialState>
  ) => {
    builder.addCase(fetchPublicWaterSystemsByAddressComponentAsync.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = '';
    })
    builder.addCase(
      fetchPublicWaterSystemsByAddressComponentAsync.fulfilled,
      (state, action: PayloadAction<IWaterSystemsData>) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      }
    )
    builder.addCase(
      fetchPublicWaterSystemsByAddressComponentAsync.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      }
    )
  }